import React from 'react';
import { IMAGES } from '../constants/images';

const Header = () => (
  <header className="flex items-center p-4 shadow-md">
    <div className="flex items-center gap-3">
      <img src={IMAGES.logo} alt="Aitag Logo" className="cursor-pointer"
        onClick={() => window.location.reload()} />
      <h1 className="text-2xl font-bold">Aitag Demo Page</h1>
    </div>
  </header>
);

export default Header;
